import { ContactUsService } from './contact-us.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { CustomValidators } from '../shared/Validators/custom-validators';
import { CustomLoadingService } from '../shared/custom-loading/custom-loading.service';
import { AppSettingService } from '../services/app-setting.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {

  public title: string = "Contact Us";
  public loggedInUser: any = [];
  public contactUsForm: FormGroup;
  errors: string[] = [];
  constructor(private activatedRoute: ActivatedRoute,private appSettingService: AppSettingService, 
    private fb: FormBuilder, private customLoadingService: CustomLoadingService,
     private service: ContactUsService) {
    this.loggedInUser = appSettingService.loggedInUser;
    this.resetContactUsFormDetails();

    this.appSettingService.SetClassOnBody(this.activatedRoute)
  }

  ngOnInit() {

  }


  submitForm(model: any, isValid: boolean) {
    try {
      if (isValid) {
        this.errors=[];
        this.customLoadingService.show();
      //  model.FirstName = null;
        this.service.SubmitContactUs(model)
          .subscribe(res => {
           
          },
          (err) => {
           
           
            this.customLoadingService.hide();
          },
          () => {
            this.customLoadingService.hide();
            setTimeout(() => {
            
            }, 5000)
           this.resetContactUsFormDetails();

          });
      }
    } catch (error) {
      this.customLoadingService.hide();
      
      setTimeout(() => {
     
      }, 5000)
      throw Error(error);

    }
  }

  resetContactUsFormDetails() {
    try {
      this.contactUsForm = this.fb.group({
        'FirstName': ['', Validators.compose([Validators.required, Validators.maxLength(255), CustomValidators.nospaceValidator])],
        'LastName': ['', Validators.compose([Validators.required, Validators.maxLength(255), CustomValidators.nospaceValidator])],
        'Title': [''],
        'Company': [''],
        'PhoneNo': ['', Validators.compose([Validators.maxLength(14)])],
        'Email': ['', Validators.compose([Validators.required, Validators.maxLength(255), CustomValidators.email, CustomValidators.nospaceValidator])],
        'Comments': [''],
      });
    } catch (error) {
      throw Error(error);
    }
  }

}
